import { createGenericContext, GetBemBlocksWith } from "@ebsco-ui/utils";

export interface CardContext {
  getBemBlocksWith: GetBemBlocksWith;
}

export const {
  useGenericContext: useCardContext,
  GenericContextConsumer: CardContextConsumer,
  GenericContextProvider: CardContextProvider,
} = createGenericContext<CardContext>({
  errorMessage:
    "Card compound components cannot be rendered outside the Card component",
});
